import React, { ReactNode } from 'react'
import { Pressable } from 'react-native'

import styled from 'styled-components/native'

import { BodyText, Size as BodyTextSize } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/bodyText/BodyText'
import { ChevronIcon, ChevronIconDirection } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/ChevronIcon'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

type CollapsiblePanelProps = {
  icon: ReactNode
  title: ReactNode
  subtitle?: ReactNode
  textColor: string
  backgroundColor: string
  children: ReactNode
  isExpanded: boolean
  onToggleExpanded: () => void
  accessibilityLabel: string
  testIDPrefix?: string
}

const Container = styled.View({
  borderRadius: 16,
  overflow: 'hidden',
})

export const Banner = styled.View<{ backgroundColor: string }>(({ backgroundColor, theme }) => ({
  backgroundColor,
  padding: theme.spacing['16px'],
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing['8px'],
}))

const BannerTextContainer = styled.View({
  flex: 1,
  flexDirection: 'column',
})

const CollapsiblePanel: React.FC<CollapsiblePanelProps> = ({
  icon,
  title,
  subtitle,
  textColor,
  backgroundColor,
  children,
  isExpanded,
  onToggleExpanded,
  accessibilityLabel,
  testIDPrefix = 'CollapsiblePanel',
}) => {
  return (
    <Container>
      <Pressable
        testID={tID(`${testIDPrefix}-toggle`)}
        onPress={onToggleExpanded}
        accessibilityRole='button'
        accessibilityLabel={accessibilityLabel}
      >
        <Banner backgroundColor={backgroundColor} testID={tID(`${testIDPrefix}-banner`)}>
          {icon}
          <BannerTextContainer>
            <BodyText
              size={subtitle ? BodyTextSize.DEFAULT : BodyTextSize.SMALL}
              medium={!!subtitle}
              color={textColor}
              text={title}
            />
            {subtitle && <BodyText size={BodyTextSize.SMALL} color={textColor} text={subtitle} />}
          </BannerTextContainer>
          <ChevronIcon
            fillColor={textColor}
            direction={isExpanded ? ChevronIconDirection.UP : ChevronIconDirection.DOWN}
          />
        </Banner>
      </Pressable>
      {isExpanded && children}
    </Container>
  )
}

export default CollapsiblePanel
